module.exports = __webpack_public_path__ + "static/media/not-the-billionaires.b3cec6fe.svg";